import { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import styles from './ModalIndisponibilidade.module.css';

export type ModalIndisponibilidadeProps = PropsWithChildren<{
  isOpen: boolean;
  onClose?: () => void;
}>;

export default function ModalIndisponibilidade({
  isOpen,
  onClose = () => {},
}: ModalIndisponibilidadeProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.modalOverlay}
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modalBody}
            onClick={(e) => e.stopPropagation()}
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 50, opacity: 0 }}
          >
            <h3 className={styles.modalTitle}>Ops!</h3>
            <p className={styles.modalMessage}>
              Atualmente não há veículos para as datas escolhidas. Por favor,
              verifique datas alternativas.
            </p>
            <button type="button" className={styles.modalButton} onClick={onClose}>
              Tentar outra data.
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
